import { render, staticRenderFns } from "./mobildDoExam.vue?vue&type=template&id=4d861b5e&scoped=true"
import script from "./mobildDoExam.vue?vue&type=script&lang=js"
export * from "./mobildDoExam.vue?vue&type=script&lang=js"
import style0 from "./mobildDoExam.vue?vue&type=style&index=0&id=4d861b5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d861b5e",
  null
  
)

export default component.exports